import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ModalStepperForm } from '../components'
import {
  AboutStep,
  AllocationStep,
  ReccurenceStep,
  SkillsTagsStep,
} from './steps'
import { CreateRotaPattern } from '@lmc/ts-common'
import useInstancesCreate from '../hooks/useInstancesCreate'
import { useRotaPatternCreate } from '../hooks/useRotaPatternCreate'
import { InitialState } from '../components/ModalStepperForm'
import useRotaGenerated, { GeneratedRota } from '../hooks/useRotaGenerated'
import GenerateEventsModal from './components/GenerateEventsModal'

type RotaPatternModalProps = {
  patternModalVisible: boolean
  onCancel: () => void
  type: 'visit' | 'shift'
}

export const RotaPatternModal: FC<RotaPatternModalProps> = ({
  patternModalVisible,
  onCancel,
  type,
}) => {
  const { t } = useTranslation()

  const [showGeneratePrompt, setShowGeneratePrompt] = useState(false)

  const [formData, setFormData] = useState<InitialState>({
    reoccurenceTooglePattern: true,
  })

  const [confirmHandler, setConfirmHandler] = useState<() => void>(
    () => () => {},
  )

  const { createPattern, isLoadingCreate } = useRotaPatternCreate({
    type,
  })

  const { createEvents } = useInstancesCreate()

  const { checkRotaGenerated } = useRotaGenerated()

  const handleFinish = async (generateEvents: boolean) => {
    const pattern: any = await createPattern({
      ...formData,
    } as CreateRotaPattern)
    // eslint-disable-next-line no-underscore-dangle
    if (pattern && pattern._id) {
      if (generateEvents) {
        createEvents?.({
          // eslint-disable-next-line no-underscore-dangle
          patternId: pattern._id,
        })
      }
      return true
    }

    return false
  }

  const onFinish = async (): Promise<boolean> => {
    const checkRotaGeneratedParams: GeneratedRota = {
      patternStartDate: formData.patternStart,
      patternEndDate: formData.hasPatternEndDate
        ? formData.patternEnd
        : undefined,
    }

    const hasRota = await checkRotaGenerated(checkRotaGeneratedParams)

    if (hasRota) {
      setShowGeneratePrompt(true)

      return new Promise((resolve) => {
        const handleModalConfirm = async (generateEvents: boolean) => {
          setShowGeneratePrompt(false)
          const result = await handleFinish(generateEvents)
          resolve(result)
        }

        setConfirmHandler(() => handleModalConfirm)
      })
    }

    return handleFinish(false)
  }

  return (
    <>
      <ModalStepperForm
        visible={patternModalVisible}
        onCancel={onCancel}
        title={t('ADD_ROTA_PATTERN')}
        steps={[
          {
            title: t('ABOUT'),
            form: <AboutStep type={type} />,
          },
          { title: t('SKILLS_AND_TAGS'), form: <SkillsTagsStep type={type} /> },
          { title: t('ASSIGN_TEAM_MEMBER'), form: <AllocationStep /> },
          {
            title: t('DATE_AND_TIME'),
            form: <ReccurenceStep type={type} />,
          },
        ]}
        onFinish={onFinish}
        isLoading={isLoadingCreate}
        formData={formData}
        setFormData={setFormData}
      />
      <GenerateEventsModal
        showPrompt={showGeneratePrompt}
        setShowPrompt={setShowGeneratePrompt}
        confirmNavigation={confirmHandler}
      />
    </>
  )
}
